import { createContext, useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useTheme } from 'styled-components';
import { useSpinDelay } from '../../hooks/useSpinDelay';
import { format } from '../../utils';
import type { InitialFetchState } from '../BlotterTable/types';
import { LoaderTalos } from '../LoaderTalos';
import { Spinner } from '../Spinner';

const messages = defineMessages({
  loadingRecords: {
    defaultMessage: 'Loading records ({count} loaded)',
    id: 'AgGrid.loadingRecords',
  },
});

const InitialFetchStateContext = createContext<InitialFetchState | undefined>(undefined);
export const InitialFetchStateProvider = InitialFetchStateContext.Provider;

export const AgGridLoadingOverlay = () => {
  const { name } = useTheme();
  const intl = useIntl();
  const fetchState = useContext(InitialFetchStateContext);

  // Delay the spinner for 200ms to avoid flickering from the observable async load
  const showSpinner = useSpinDelay(true, { delay: 200 });
  if (!showSpinner) {
    return null;
  }

  const loadingText =
    fetchState && fetchState.loadedCount > 0
      ? intl.formatMessage(messages.loadingRecords, { count: format(fetchState.loadedCount) })
      : undefined;

  return name.includes('Default') || name.includes('TalosMobile') ? <LoaderTalos text={loadingText} /> : <Spinner />;
};
